const requireContext = require.context('./modules', true, /.*\.js$/)
requireContext.keys().forEach((file) => {
    requireContext(file)
})
